import React from 'react';

const ToggleSwitch: React.FC<{
  id: string;
  label?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}> = ({ id, label, checked, onChange }) => (
  <div className="flex items-center space-x-3">
    <div className="relative">
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="sr-only"
      />
      <label
        htmlFor={id}
        className={`block w-14 h-8 rounded-full cursor-pointer transition-colors ${
          checked ? 'bg-netlify-teal' : 'bg-gray-300'
        }`}
      >
        <div
          className={`absolute top-1 left-1 bg-white w-6 h-6 rounded-full shadow-md transition-transform ${
            checked ? 'translate-x-6' : 'translate-x-0'
          }`}
        />
      </label>
    </div>
    {label && <label htmlFor={id} className="font-medium text-gray-900 cursor-pointer">
      {label}
    </label>}
  </div>
);

export default ToggleSwitch;